import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.PROJECTS,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ProjectsContainer'),
      import('./reducers')
    ])
    injectReducer(store, { key: 'projects', reducer: reducer.default })

    cb(null, module.default)
  }
})
